import '../sass/jsoneditor.scss';
import JSONEditor from 'jsoneditor';
window.JSONEditor = JSONEditor

window.JsonApp = (function () {
    let editorInstance = null,
        editor = null;
    let config = {};
    let hiddenField = null;

    const jsonEditor = function () {
        const editorElement = document.getElementById("jsoneditor");
        if (!editorElement) {
            console.warn('JSON Editor container not found');
            return;
        }

        // Find or create hidden field
        hiddenField = document.getElementById(config.hiddenFieldId);
        if (!hiddenField) {
            hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.id = config.hiddenFieldId;
            hiddenField.name = config.hiddenFieldName;
            editorElement.parentNode.appendChild(hiddenField);
        }

        editorInstance = new JSONEditor(editorElement, {
            mode: config.mode,
            modes: config.modes,
            mainMenuBar: config.menuBar,
            statusBar: config.statusBar,
            onChange: function () {
                syncToHiddenField(); // Sync when content changes
            },
            onError: function (err) {
                if (typeof ArtisanApp !== 'undefined' && ArtisanApp.toastError) {
                    ArtisanApp.toastError(err.toString());
                } else {
                    console.error('JSON Editor Error:', err);
                }
            },
        });

        // Initial sync
        setTimeout(syncToHiddenField, 100);
    },

        syncToHiddenField = function () {
            if (!hiddenField || !editorInstance) return;

            try {
                const jsonText = editorInstance.getText();
                hiddenField.value = jsonText;
            } catch (error) {
                console.error('Error syncing to hidden field:', error);
                hiddenField.value = '';
            }
        },

        attachEvents = function () {
            // Check if required elements exist before attaching events
            const fileInput = document.getElementById('fileInput');
            const urlUpload = document.getElementById('urlUpload');
            const jsonToolAction = document.getElementById('json-tool-action');
            const saveToFile = document.getElementById('saveToFile');

            if (fileInput) {
                fileInput.addEventListener('change', e => {
                    var file = document.getElementById("fileInput").files[0];
                    if (file && file.type != "application/json") {
                        showError(config.invalidFileMessage);
                        return;
                    }
                    JsonApp.setFileContent(file);
                });
            }

            if (urlUpload) {
                urlUpload.addEventListener('input', e => {
                    urlContent(e.target);
                });
            }

            // Initialize second editor if needed and container exists
            if (config.mode2 !== false) {
                const resultsContainer = document.getElementById("json--results-container");
                if (resultsContainer) {
                    editor = new JSONEditor(resultsContainer, {
                        mode: config.mode2,
                        modes: ['code', 'form', 'text', 'tree', 'view'],
                        onError: function (err) {
                            showError(err.toString());
                        },
                    });
                    if (editor.frame) {
                        const outerElement = editor.frame.querySelector('.jsoneditor-outer');
                        if (outerElement) {
                            outerElement.classList.add('mh-400');
                        }
                    }
                }
            } else {
                editor = editorInstance;
            }

            if (jsonToolAction) {
                jsonToolAction.addEventListener('click', () => {
                    if (typeof APP !== 'undefined' && APP.updateContent) {
                        APP.updateContent();
                    }
                });
            }

            if (saveToFile && editor) {
                saveToFile.addEventListener('click', () => {
                    if (typeof ArtisanApp !== 'undefined' && ArtisanApp.downloadAsTxt) {
                        ArtisanApp.downloadAsTxt(editor.getText(), {
                            isElement: false,
                            filename: config.filename
                        });
                    } else {
                        // Fallback download method
                        downloadText(editor.getText(), config.filename);
                    }
                });
            }

            // Also sync on blur events
            if (editorInstance) {
                editorInstance.aceEditor?.container.addEventListener('blur', syncToHiddenField);
            }
        },

        urlContent = function (element) {
            var url = element.value;
            if (!url) return;

            var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;

            if (urlRegex.test(url)) {
                fetch(url)
                    .then(res => res.json())
                    .then(out => {
                        if (editorInstance) {
                            editorInstance.set(out);
                            syncToHiddenField(); // Sync after URL load
                        }
                    })
                    .catch(err => {
                        showError(config.fetchError);
                    });
            }
        },

        showError = function (message) {
            if (typeof ArtisanApp !== 'undefined' && ArtisanApp.toastError) {
                ArtisanApp.toastError(message);
            } else {
                alert(message); // Fallback error display
            }
        },

        downloadText = function (text, filename) {
            const blob = new Blob([text], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        };

    return {
        init: function (initConfig = {}) {
            // Set default configuration
            config = {
                mode: 'tree',
                modes: [],
                mode2: false,
                invalidFileMessage: 'Invalid file type',
                filename: 'output.txt',
                errorReadingFile: 'Error reading file',
                fetchError: 'Error fetching URL',
                invalidJson: 'Invalid Json Input',
                menuBar: true,
                statusBar: true,
                hiddenFieldId: 'json_data',
                hiddenFieldName: 'json_data',
                ...initConfig
            };

            // Check if the main editor container exists
            const editorContainer = document.getElementById("jsoneditor");
            if (!editorContainer) {
                console.warn('JSON Editor not initialized: container element not found');
                return false;
            }

            jsonEditor();
            attachEvents();
            return true;
        },

        initResult: function () {
            const resultElement = document.querySelector('.json-tool-result');
            if (resultElement) {
                resultElement.classList.remove('d-none');
                resultElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },

        setFileContent: function (file) {
            if (!editorInstance) {
                showError('Editor not initialized');
                return;
            }

            var reader = new FileReader();
            reader.readAsText(file, "UTF-8");
            reader.onload = function (evt) {
                editorInstance.setText(evt.target.result);
                syncToHiddenField(); // Sync after file load
            }
            reader.onerror = function (evt) {
                showError(config.errorReadingFile);
            }
        },

        validateEditor: async function () {
            if (!editorInstance) {
                showError('Editor not initialized');
                return false;
            }

            let state = false;
            await editorInstance.validate()
                .then(res => {
                    if (res.length != 0) {
                        res.forEach(r => {
                            showError(r.message);
                        });
                    } else {
                        state = true;
                    }
                });

            return state;
        },

        editor: function () {
            return editorInstance;
        },

        editor2: function () {
            return editor;
        },

        getData: function () {
            return editor ? editor.getText() : '';
        },

        // NEW: Manual sync method
        syncHiddenField: function () {
            syncToHiddenField();
        },

        // NEW: Get the hidden field reference
        getHiddenField: function () {
            return hiddenField;
        },

        // NEW: Format JSON in editor 1
        formatEditor1: function (spaces = 2) {
            if (!editorInstance) {
                showError('First editor not available');
                return false;
            }

            try {
                const currentText = editorInstance.getText();
                const jsonData = JSON.parse(currentText);
                const formattedJson = JSON.stringify(jsonData, null, spaces);
                editorInstance.setText(formattedJson);
                syncToHiddenField(); // Sync after formatting
                return true;
            } catch (error) {
                console.error('Error formatting JSON in editor 1:', error);
                showError('Invalid JSON - cannot format');
                return false;
            }
        },

        // NEW: Minify JSON in editor 1
        minifyEditor1: function () {
            if (!editorInstance) {
                showError('First editor not available');
                return false;
            }

            try {
                const currentText = editorInstance.getText();
                const jsonData = JSON.parse(currentText);
                const minifiedJson = JSON.stringify(jsonData);
                editorInstance.setText(minifiedJson);
                syncToHiddenField(); // Sync after minifying
                return true;
            } catch (error) {
                console.error('Error minifying JSON in editor 1:', error);
                showError('Invalid JSON - cannot minify');
                return false;
            }
        },

        // Optional: Method to update config after initialization
        updateConfig: function (newConfig) {
            config = { ...config, ...newConfig };
        },

        // Check if editor is available
        isAvailable: function () {
            return !!editorInstance;
        }
    };
})();